/**
 * **按设备挑提示条上要显示的那几条**（纯函数，方便断言）。
 *
 * ## 为什么是"挑"而不是"改文案"
 *
 * 桌面端和触摸端能做的事**根本不是一套**：手机上没有滚轮、没有 Delete、
 * 没有 Ctrl+Z，有的是"双指捏合 / 单指拖动 / 长按"。真机反馈原话：
 * "应该是非移动端的时候，才显示滚轮、Delete 删掉还有快捷键，移动端的时候
 * 应该显示手指的操作"。
 *
 * 所以每条提示可以带一份 `touchKeys / touchLabel`：
 *   · 桌面端 → 用 `keys / label`；
 *   · 触摸端 → 有 `touchKeys` 就用它，**没有就整条不显示**。
 *
 * ⚠️ 最后那条"没有就不显示"是刻意的：在手机上写"Del 删掉选中的组件"
 * 比什么都不写更糟 —— 用户会去找那个不存在的键。
 *
 * ⚠️ 抽成纯函数的理由：`touchDevice` 是运行期从媒体查询 + 指针类型判出来的，
 * 无头环境里翻不动它。判定留在这里，两边（提示条 / 帮助）都调它，
 * 也就能被逐条断言。
 */
import type { EditorTip } from '../types/editor'

export interface TipForDevice {
  keys: string
  label: string
}

export function pickTips(tips: readonly EditorTip[] | undefined, touch: boolean): TipForDevice[] {
  if (!tips) return []
  const out: TipForDevice[] = []
  for (const tip of tips) {
    if (!touch) {
      out.push({ keys: tip.keys, label: tip.label })
      continue
    }
    if (tip.touchKeys) out.push({ keys: tip.touchKeys, label: tip.touchLabel ?? tip.label })
  }
  return out
}
